import { LinkmailType } from './breakdown';
import { IPaginatedData } from './common';

export enum FollowUpFilterStatus {
  Active,
  Archived,
  Deleted,
}

export enum FollowUpIncludePersonalDetails {
  NameOnly = 0,
  NameAndEmail = 1,
}

export type FollowUpId = string;

export interface IFollowUp {
  id: FollowUpId;
  subject: string;
  body: string;
  created: string;
  linkmailId: string;
  productionTypeId: number;
  productionTitle: string;
  linkmailType: LinkmailType;
  amendmentCount: number;
  includePersonalDetails: FollowUpIncludePersonalDetails;
  linkmailSentDate: string;
  sentBy: string;
}

export interface ICreateFollowUp {
  subject: string;
  body: string;
  includePersonalDetails: FollowUpIncludePersonalDetails;
}

export interface IFollowUpRecipientListItem {
  fullName: string;
  agencyName: string;
}

export interface IPaginatedFollowUpRecipientList extends IPaginatedData<IFollowUpRecipientListItem> {}

export interface IPaginatedFollowUpList extends IPaginatedData<IFollowUp> {}
